export const DOMAIN_API_JOB_ASSIGN = 'https://vcapi.viettelmedia.vn/ReengBackendBiz/job-assign/';
export const DOMAIN = 'https://work.viettelmedia.vn/';



